import { create } from "zustand";
import { handleErrorResponse } from "../functions";
import { AdministrationService, CacheListResponse } from "@/api-client";

interface CacheListInterface {
  cacheList: CacheListResponse | null;
  cacheListLoading: boolean;
  loadCacheList: () => Promise<void>;
  setCacheList: (value: CacheListResponse | null) => void;
}

export const useCacheListStore = create<CacheListInterface>((set, get) => ({
  cacheList: null,
  cacheListLoading: false,
  setCacheList: (value: CacheListResponse | null) => set({ cacheList: value }),
  loadCacheList: async () => {
    const { cacheListLoading } = get();

    if (cacheListLoading) {
      return;
    }

    set({ cacheListLoading: true });

    try {
      const { data, error } = await AdministrationService.cacheList();

      if (error) {
        handleErrorResponse(error);
        return;
      }

      set({ cacheList: data?.data, cacheListLoading: false });
    } catch (error) {
      console.error("Error loading data:", error);
      set({ cacheListLoading: false });
    }
  },
}));
